import { attribute } from "@bodil/dom/component";
import { customElement } from "lit/decorators.js";

import { BtkMenuItem } from "./menu-item";

declare global {
    interface HTMLElementTagNameMap {
        "btk-combo-box-item": BtkComboBoxItem;
    }
}

@customElement("btk-combo-box-item")
export class BtkComboBoxItem extends BtkMenuItem {
    @attribute accessor value: string | null = null;

    getContents(): unknown {
        return this.childNodes.values().map((node) => node.cloneNode());
    }
}
